import { CHART_TYPES, CHART_SIZES, FILTER_FIELDS } from "@hub/dashboard/src/constants"

export const TERMS_STATUS = {
  active: "active",
  editing: "editing",
  deactivated: "deactivated"
}

export const LAYOUT_OPTIONS = {
  PROVIDER: "provider",
  CHAIN: "chain"
}

export const TERM_FORMAT_OPTIONS = {
  ESCRITA: "ESCRITA",
  IMPORTACAO: "IMPORTACAO"
}

export const LOGO_MAX_SIZE = 500000 // 500kb

export const NOTE_TYPES_STATUS_BADGES_TYPES = {
  Aguardando: "waiting",
  Aprovado: "approved",
  Reprovado: "disapproved",
  Desistência: "abandoned",
  Cancelado: "canceled",
  Pendente: "pending",
  Finalizado: "approved",
  Reenvio: "waiting"
}

export const NOTE_TYPES_CATEGORIE = {
  status: "Status",
  pending: "Pendência",
  biometric: "Biometria"
}

export const NOTE_TYPES_TYPE = {
  order: "order",
  service: "service"
}

export const REASONS_STATUS = {
  active: 1,
  deactivated: 0
}

export const PENDING_DESCRIPTION = {
  pending: "Pendente",
  finished: "Finalizado"
}

export const FLOW_STATUSES_BADGE = {
  ACTIVE: "success",
  INACTIVE: "error"
}

export const FLOW_ICONS_OPTIONS = [
  {
    name: "pap",
    icon: require("@hub/order/src/assets/images/flows/hand-holding-phone-icon.svg")
  },
  {
    name:"condominium",
    icon: require("@hub/order/src/assets/images/flows/condominium-icon.svg")
  },
  {
    name:"webdealer",
    icon: require("@hub/order/src/assets/images/flows/suport-icon.svg")
  },
  {
    name: "preorder",
    icon: require("@hub/order/src/assets/images/flows/pre-order.svg")
  }
]

export const SALE_FLOW_OPTIONS = [
  {text: "Pedido", value: "Pedido", canEdit: false, disabled: false},
  {text: "Dados do Cliente", value: "Dados do Cliente", canEdit: false, disabled: false},
  {text: "Análise", value: "Análise", canEdit: false, disabled: false},
  {text: "Mapa de viabilidade", value: "Mapa de Viabilidade", canEdit: false, disabled: false},
  {text: "Ofertas", value: "Ofertas", canEdit: false, disabled: false},
  {text: "Serviços Adicionais", value: "Serviços Adicionais", canEdit: false, disabled: false},
  {text: "Personalizar Serviço", value: "Personalizar Serviço", canEdit: false, disabled: false},
  {text: "Fatura", value: "Fatura", canEdit: false, disabled: false},
  {text: "Documentos", value: "Documentos", canEdit: false, disabled: false},
  {text: "Termos de Aceite", value: "Termos de Aceite", canEdit: false, disabled: false},
  {text: "Detalhes do pedido", value: "Detalhes do Pedido", canEdit: false, disabled: false},
  {text: "Agendamento", value: "Agendamento", canEdit: false, disabled: false},
  {text: "Resumo", value: "Resumo", canEdit: false, disabled: false},
  {text: "Pagamento via Pix", value: "Pagamento via Pix", canEdit: false, disabled: false}
]

export const SALE_FLOW_SCHEDULE_OPTION_VALUE = "Agendamento"

export const IS_COPYING_VALUE = {
  active: 1,
  inactive: 0
}

export const STATUSES_FLOWS_TEXT = {
  active: "ATIVO",
  inactive: "INATIVO"
}

export const DEFAULT_VISIT_FLOW_NAMES = [
  "Sim, iniciar pedido",
  "Cliente ausente",
  "Não teve interesse",
  "Interesse futuro (Lead)"
]

export const VISIT_FLOW_DAFAULT_ICON = "house-chimney-user"

export const TERMS_STEPS = ["Visibilidade", "Termo", "Cobertura"]

export const TERMS_STEP_NAME_ROUTES = [
  "terms-visibility",
  "terms-term",
  "terms-coverage"
]

export const VALID_NATIONWIDE_OPTIONS = [
  {
    label: true,
    title: "Sim"
  },
  {
    label: false,
    title: "Não"
  }
]

export const COVERAGE_OPTIONS = [
  {
    title: "Cidade",
    cardTitle: "Cobertura por cidade",
    type: "city",
    amount: 0,
    active: false,
    label: "Cidades selecionadas",
    form: "VCityForm"
  }
]

export const COVERAGE_TYPE = {
  city: "city",
}

export const SETTINGS_ROUTES_DASH_MOBILE_ACTIONS = {
  TERMS: "terms",
  NOTE_TYPES_EDIT: "note-types-edit",
  FLOW_LIST: "flow-list",
  VISIT_FLOW_LIST: "visit-flow-list",
  BIOMETRY_FLOW_LIST: "biometry-flow-list",
  DASHBOARDS_LIST: "dashboards",
}

export const SEND_LINK_WHATSAPP = {
  ACTIVE: 1,
  INACTIVE: 0
}

export const COMMISSION_STEPS = [
  "Informações",
  "Produtos",
  "Configurações"
]

export const COMMISSION_STEP_NAME_ROUTES = [
  "",
  "commissions-info",
  "commissions-products",
  "commissions-settings"
]

export const COMMISSION_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  EXPIRED: "EXPIRED"
}

export const STATUS_BADGE_TYPE = {
  ACTIVE: "success",
  INACTIVE: "error",
  EXPIRED: "expired",
  NONE: "disabled"
}

export const STATUS_BADGE_STATUS = {
  ACTIVE: "Ativo",
  INACTIVE: "Inativo",
  EXPIRED: "Expirado",
  NONE: "-"
}

export const RESTRICTION_STATUS = [
  {
    id: "total_amount",
    type: "awaiting",
    icon: "",
    title: "Total de comissões",
  },
  {
    id: "active_amount",
    type: "active",
    icon: "",
    title: "Comissões ativas",
  },
]

export const RESTRICTION_MAPPING = {
  total: "total",
  active: "active",
}

export const ACTIONS = {
  FILTER: {
    text: "Filtros",
    icon: "filter",
    value: "",
    on: "filter"
  },
  CREATE_NEW_COMMISSION: {
    text: "Nova comissão",
    icon: "plus",
    value: "",
    on: "create"
  },
  EXPORT_RESULTS: {
    text: "Exportar Resultados",
    icon: "download-cloud",
    value: "",
    on: "export"
  },
}

export const DASHBOARD_STEPS = [
  "Gerais",
  "Gráficos",
  "Filtros",
  "Funções"
]

export const DASHBOARD_STEP_NAME_ROUTES = [
  "",
  "dashboards-general",
  "dashboards-tabs",
  "dashboards-filters",
  "dashboards-roles"
]

export const DASHBOARD_FILTER_SCOPE = {
  GLOBAL: "global",
  QUICK: "quick"
}

export const CHART_TYPE_OPTIONS = [
  { text: "KPI", value: CHART_TYPES.KPI },
  { text: "Linha", value: CHART_TYPES.LINE },
  { text: "Barra", value: CHART_TYPES.BAR },
  { text: "Área", value: CHART_TYPES.AREA },
  { text: "Donut", value: CHART_TYPES.DONUT },
  { text: "Pizza", value: CHART_TYPES.PIE },
  { text: "Treemap", value: CHART_TYPES.TREEMAP },
  { text: "Tabela", value: CHART_TYPES.TABLE },
  { text: "Combo", value: CHART_TYPES.COMBO },
  { text: "Mapa", value: CHART_TYPES.MAP },
  { text: "Barra empilhada", value: CHART_TYPES.STACKED_BAR }
]

export const CHART_TYPE_ICON = {
  [CHART_TYPES.KPI]: "hash",
  [CHART_TYPES.LINE]: "trending-up",
  [CHART_TYPES.BAR]: "bar-chart-2",
  [CHART_TYPES.AREA]: "activity",
  [CHART_TYPES.DONUT]: "pie-chart",
  [CHART_TYPES.PIE]: "pie-chart",
  [CHART_TYPES.TREEMAP]: "grid",
  [CHART_TYPES.TABLE]: "list",
  [CHART_TYPES.COMBO]: "bar-chart",
  [CHART_TYPES.MAP]: "map",
  [CHART_TYPES.STACKED_BAR]: "layers"
}

export const CHART_SIZE_OPTIONS = [
  { text: "Pequeno (1/6)", value: CHART_SIZES.SMALL },
  { text: "Médio (2/6)", value: CHART_SIZES.MEDIUM },
  { text: "Grande (3/6)", value: CHART_SIZES.LARGE },
  { text: "Linha inteira (6/6)", value: CHART_SIZES.FULL }
]

export const MAX_CHARTS_PER_TAB = 15

export const FILTER_TYPE_OPTIONS = [
  { text: "Período", value: FILTER_FIELDS.DATE_RANGE },
  { text: "Atalho de período", value: FILTER_FIELDS.DATE_RANGE_SELECT },
  { text: "Texto", value: FILTER_FIELDS.TEXT },
  { text: "Seleção única", value: FILTER_FIELDS.SELECT },
  { text: "Grupo de botões", value: FILTER_FIELDS.SELECT_BUTTON },
  { text: "Rede / PDV", value: FILTER_FIELDS.CHAIN_POS },
  { text: "UF / Cidade", value: FILTER_FIELDS.STATE_CITY },
  { text: "Autocomplete de vendedor", value: FILTER_FIELDS.AUTOCOMPLETE }
]

export const FILTER_TYPE_ICON = {
  [FILTER_FIELDS.DATE_RANGE]: "calendar",
  [FILTER_FIELDS.DATE_RANGE_SELECT]: "clock",
  [FILTER_FIELDS.TEXT]: "type",
  [FILTER_FIELDS.SELECT]: "list",
  [FILTER_FIELDS.SELECT_BUTTON]: "sliders",
  [FILTER_FIELDS.CHAIN_POS]: "map-pin",
  [FILTER_FIELDS.STATE_CITY]: "map",
  [FILTER_FIELDS.AUTOCOMPLETE]: "search"
}

export const FILTER_TYPE_DESCRIPTION = {
  [FILTER_FIELDS.DATE_RANGE]: "Seleção de período (data inicial e final)",
  [FILTER_FIELDS.DATE_RANGE_SELECT]: "Atalho rápido de período",
  [FILTER_FIELDS.TEXT]: "Campo de texto livre",
  [FILTER_FIELDS.SELECT]: "Seleção única em lista",
  [FILTER_FIELDS.SELECT_BUTTON]: "Seleção única em grupo de botões",
  [FILTER_FIELDS.CHAIN_POS]: "Seleção única de rede e PDV",
  [FILTER_FIELDS.STATE_CITY]: "Seleção única de estado e cidade",
  [FILTER_FIELDS.AUTOCOMPLETE]: "Busca e seleção única de vendedor"
}

export const AVAILABLE_FILTERS = [
  { id: "date_range", label: "Período", type: FILTER_FIELDS.DATE_RANGE, required: true },
  { id: "chain_pos", label: "Rede / PDV", type: FILTER_FIELDS.CHAIN_POS, required: false },
  { id: "state_city", label: "UF / Cidade", type: FILTER_FIELDS.STATE_CITY, required: false },
  { id: "seller_uuid", label: "Vendedor", type: FILTER_FIELDS.AUTOCOMPLETE, required: false },
  { id: "plan", label: "Plano", type: FILTER_FIELDS.TEXT, required: false }
]

export const AVAILABLE_QUICK_FILTERS = [
  {
    id: "granularity",
    label: "Granularidade",
    type: FILTER_FIELDS.SELECT_BUTTON,
    required: false,
    defaultValue: "month",
    options: [
      { title: "Dia", label: "day", name: "granularity", maxDateRange: 15, maxDateRangeLabel: "15 dias" },
      { title: "Semana", label: "week", name: "granularity", maxDateRange: 84, maxDateRangeLabel: "12 semanas" },
      { title: "Mês", label: "month", name: "granularity" },
      { title: "Ano", label: "year", name: "granularity" }
    ]
  }
]

export const EMPTY_DASHBOARD_ROLES_OPTIONS_INFO_TEXT = {
  title: "Não há funções disponíveis, pois todas já estão vinculadas a fluxos ativos.",
  text: "Você pode concluir o cadastro sem funções e vinculá-las depois, editando o fluxo."
}
export const DIGITAL_DOCUMENT_OPTIONS = [
  {
    text: "CNH",
    value: 2
  },
  {
    text: "RG",
    value: 3
  },
  {
    text: "CIN",
    value: 4
  }
]

export const BIOMETRY_FLOW_VERSION_OPTIONS = [
  {
    text: "v1",
    value: "v1"
  },
  {
    text: "v2",
    value: "v2"
  }
]

export const DEFAULT_VERSION = "v2"
